import {
    HttpInterceptorFn,
    HttpRequest,
    HttpHandlerFn,
    HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

export const basePropertiesInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {

    if (request.url.startsWith('/assets/')) {
        return next(request);
    }

    let headers = request.headers.append('x-client-id', environment.clientId);

    const excludedUrlPattern =
        /^\/selfcare\/vehicles\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/documents$/;
    const excludedDriversUrlPattern =
        /^\/selfcare\/drivers\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/documents\/$/;
    const excludedLogosUrlPattern =
        /^\/admin\/providers\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\/logo$/;
    const shouldAddContentTypeHeader: boolean =
        excludedUrlPattern.test(request.url) ||
        excludedDriversUrlPattern.test(request.url) ||
        excludedLogosUrlPattern.test(request.url)

    if(request.method==='GET' && excludedLogosUrlPattern.test(request.url)){
        headers = headers.append('Content-Type', 'application/json');
        const requestWithCustomHeader = request.clone({
            url: `${environment.apiUrl}${request.url}`,
            headers: headers,
        });
        return next(requestWithCustomHeader);
    }

    if (excludedLogosUrlPattern.test(request.url)) {
        headers = headers.delete('Content-Type', 'application/json');
        const requestWithCustomHeader = request.clone({
            url: `${environment.apiUrl}${request.url}`,
            headers: headers,
        });
        return next(requestWithCustomHeader);
    }

    if (!shouldAddContentTypeHeader) {
        headers = headers.append('Content-Type', 'application/json');
    }

    const requestWithCustomHeader = request.clone({
        url: `${environment.apiUrl}${request.url}`,
        headers: headers,
    });

    return next(requestWithCustomHeader);
};
